// extracted by mini-css-extract-plugin
module.exports = {"main":"main__7nIcy"};